import { DefaultQueryParams } from '@frontend/api-utils';
import { ChartClient } from '@frontend/chart/api';
import { IotsVolumeByStatusBarChart } from '@frontend/chart/components';
import { Chart, ChartBinSize, ChartQueryParam } from '@frontend/chart/types';
import { useEffect, useState } from 'react';

import { useInsightFetchRange } from '../../../analytics/insights/insight-detail/use-insight-fetch-range';
import { getLast30DaysChartRange } from '../../pudo/last-30-days-chart-range';
import { Last30DaysHardwareIotsVolumeByStatusBarChartProps } from './last-30-days-hardware-iots-volume-by-status-bar-chart.component';

export const useLast30DaysHardwareIotsVolumeByStatusBarChart = (props: Last30DaysHardwareIotsVolumeByStatusBarChartProps) => {
    const [data, setData] = useState<Chart | undefined>(undefined);
    const [isLoading, setIsLoading] = useState(true);

    const fetchRange = useInsightFetchRange(getLast30DaysChartRange, { defaultBinSize: ChartBinSize.DAY, useDetailBinSize: true });

    useEffect(() => {
        if (!props.accountId) {
            setIsLoading(false);
            return;
        }

        let cancelled = false;
        setIsLoading(true);

        const { after, before } = fetchRange;

        ChartClient.fetchChartData(props.accountId, IotsVolumeByStatusBarChart.definition, {
            [DefaultQueryParams.AFTER]: after,
            [DefaultQueryParams.BEFORE]: before,
            ...fetchRange.entityParams,
            [ChartQueryParam.BIN_SIZE]: fetchRange.binSize!
        })
            .then((chart) => {
                if (!cancelled) {
                    setData(chart);
                }
            })
            .catch(() => {
                if (!cancelled) {
                    setData(undefined);
                }
            })
            .finally(() => {
                if (!cancelled) {
                    setIsLoading(false);
                }
            });

        return () => {
            cancelled = true;
        };
    }, [props.accountId, fetchRange.key]);

    return { data, isLoading };
};
